import React, {
  Component
} from 'react';
import {
  autobind
} from 'core-decorators';
import { Modal,Menu} from 'antd-mobile';
import tools from '../../utils/tools';
import PropTypes from 'prop-types';
import {
  observer
} from 'mobx-react';
import './style.less';
import Icon from '../Icon';

const preventEvent = (event) => {
  if (event) {
    event.preventDefault();
    event.stopImmediatePropagation && event.stopImmediatePropagation();
    event.stopPropagation();
  }
};

@observer
export default class SearchDropDown extends Component {
  static propTypes = {
    report: PropTypes.object,
  };

  state = {}

  hide = ()=>{
    this.setState({
      open: false
    });
  }

  handleTouchTap = (event) => {
    preventEvent(event);
    this.setState({
      open: true,
      anchorEl: event.currentTarget
    });
  }

  handleRequestClose = (item) => {
    preventEvent(event);
    if (this.state.open == false) {
      return;
    }
    this.setState({
      open: false
    });
    this.props.report.changePlan(item.id);
  }

  handleTouchStart = ()=>{
    this.touchStart = new Date().getTime();
  }

  handleTouchEnd = ()=>{
    const timer = (new Date().getTime() - this.touchStart)/1000;
    if (timer>5){
      // 刷新方案
      this.props.report.loadSearchPlan(true);
    }
  }

  renderItems() {
    const {
      searchPlan,
      searchPlans
    } = this.props.report;
    return searchPlans.map((item, index) => {
      return {value:item.id,label:item.name};
    });
  }

  onChange = (value) => {
   this.handleRequestClose({id:value[0]})
 }

  render() {
    const {
      searchPlan
    } = this.props.report;
    let initData = this.renderItems();
    return (
      <div className="searchDropDown">
            <div className="bar" onClick={this.handleTouchTap} onTouchStart={this.handleTouchStart} onTouchEnd={this.handleTouchEnd}>
                <Icon type='baobiao'/>
                <span>{searchPlan.name}</span>
                <Icon type='xia'/>
            </div>

            <Modal
                popup
                wrapClassName ='searchDropDown-modal-wrap'
                visible={this.state.open}
                animationType="slide-down">
                <Menu
                  className="single-foo-menu"
                  data={initData}
                  value={[searchPlan.id]}
                  level={1}
                  onChange={this.onChange}
                  height={document.documentElement.clientHeight * 0.6}/>
            </Modal>
          </div>
    );
  }
}
